// extracted by mini-css-extract-plugin
export default {"insideStyle":"parallax_insideStyle__MB6nH"};